import { useUserMembershipsQuery } from '~/generated/graphql';

export function useUserMemberships() {
  const { data, loading, refetch } = useUserMembershipsQuery();

  return {
    loading,
    memberships: data?.viewer?.user?.memberships?.nodes ?? [],
    refetchMemberships: refetch,
  };
}
